// extracted by mini-css-extract-plugin
export default {"preferenceChip":"PreferenceChip_preferenceChip__TOVfK","selected":"PreferenceChip_selected__Mcw+-","allocatedChip":"PreferenceChip_allocatedChip__W6hUv"};